import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GRID_CONSTANTS } from '@go-modules/components/grid-virtual-scroll-viewport/grid.constants';
import { ActivityListDataSource } from '@go-modules/services/activity-list-datasource/activity-list.datasource';
import { ResponsiveLayoutService } from '@go-modules/services/responsive-layout/responsive-layout.service';

@Component({
	selector: 'activity-grid-view',
	templateUrl: './activity-grid-view.component.html',
	styleUrls: ['./activity-grid-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	host: {
		'[class]': 'responsiveLayout.cssClassString()'
	}
})
export class NgxActivityGridViewComponent {
	protected responsiveLayout = inject(ResponsiveLayoutService);

	public minWidth: number = GRID_CONSTANTS.minWidth;
	public maxWidth: number = GRID_CONSTANTS.maxWidth;
	public minGap: number = GRID_CONSTANTS.minGap;

	constructor (public activityListDataSource: ActivityListDataSource) {}
}
